import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "users flex-grow-1" }
const _hoisted_2 = { class: "mb-2 max-width-text" }
const _hoisted_3 = { class: "flex flex-justify-between flex-align-center" }
const _hoisted_4 = { class: "white pa-2 flex-grow-1" }
const _hoisted_5 = { class: "users__search" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 1,
  class: "users__search-icon"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "users__pagination mt-2"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled", "onClick"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  class: "users-transition-content",
  key: "content"
}
const _hoisted_14 = {
  class: "loading mt-2",
  key: "loader"
}
const _hoisted_15 = {
  class: "users__overview mt-2",
  key: "users"
}
const _hoisted_16 = {
  key: 2,
  class: "no-results"
}
const _hoisted_17 = {
  key: 3,
  class: "users__sheet-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_row = _resolveComponent("user-row")!
  const _component_crud_user = _resolveComponent("crud-user")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showText)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.USERS')), 1),
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.USER.DESCRIPTION')), 1)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "users__search-input",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            placeholder: _ctx.showCompany ? _ctx.$t("MY_ENVIRONMENT.USER.SEARCH_TEXT_COMPANY") : _ctx.$t("MY_ENVIRONMENT.USER.SEARCH_TEXT")
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.searchQuery]
          ]),
          (_ctx.searchQuery)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "users__search-clear",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = ""))
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "icons8-delete" }, null, -1)
              ]))]))
            : _createCommentVNode("", true),
          (!_ctx.searchQuery)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "icons8-search" }, null, -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.hasAnyPermission([_ctx.permissions.UserCreate, _ctx.permissions.UserAdministratorCreate, _ctx.permissions.UserManagerCreate, _ctx.permissions.UserSupportCreate]))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "users__create-button ml-2",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openCreateUserSheet && _ctx.openCreateUserSheet(...args))),
            disabled: (_ctx.impersonated && !_ctx.impersonatedWithOriginalRights),
            type: "button"
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "icons8-user" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t('MY_ENVIRONMENT.USER.CREATE_USER')), 1)
          ], 8, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToPreviousPage && _ctx.goToPreviousPage(...args))),
            disabled: _ctx.currentPage <= 1
          }, "Prev", 8, _hoisted_10),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePageTokens, (token, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: `page-${index}-${token}`,
              type: "button",
              disabled: token === "...",
              class: _normalizeClass({ "is-active": token === _ctx.currentPage, "is-ellipsis": token === "..." }),
              onClick: ($event: any) => (_ctx.goToPage(token))
            }, _toDisplayString(token), 11, _hoisted_11))
          }), 128)),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToNextPage && _ctx.goToNextPage(...args))),
            disabled: _ctx.currentPage >= _ctx.totalPages
          }, "Next", 8, _hoisted_12)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.loading && !_ctx.showCrudUser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageSize, (n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "users__skeleton mt",
                    key: n
                  }))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entities, (user) => {
                  return (_openBlock(), _createBlock(_component_user_row, {
                    user: user,
                    key: user.email,
                    onEditUser: ($event: any) => (_ctx.showCrudUserSheet($event.user, $event.action))
                  }, null, 8, ["user", "onEditUser"]))
                }), 128))
              ]))
        ])
      ]),
      _: 1
    }),
    (_ctx.showNoResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.USER.NO_USERS_FOUND')), 1))
      : _createCommentVNode("", true),
    (_ctx.showCrudUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", {
            class: _normalizeClass(["users__sheet", {"red-border" : _ctx.action === _ctx.userActions.Inactive || _ctx.action === _ctx.userActions.Delete }])
          }, [
            (_ctx.showCrudUser)
              ? (_openBlock(), _createBlock(_component_crud_user, {
                  key: 0,
                  onHide: _ctx.close,
                  "edit-user": _ctx.user,
                  action: _ctx.action,
                  companies: _ctx.companies
                }, null, 8, ["onHide", "edit-user", "action", "companies"]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}